import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=9d597486&scoped=true&"
import script from "./PostItem.vue?vue&type=script&lang=ts&"
export * from "./PostItem.vue?vue&type=script&lang=ts&"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=9d597486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d597486",
  null
  
)

export default component.exports